import React from 'react';
import { useSecurity } from '../../helpers/SecurityHooks';
import { useParams } from 'react-router-dom';
import { appendScriptsCallback } from '../../helpers/Utils';

export function IndexForecastPage(): React.ReactElement {
  const { id } = useParams();
  const currentSecurity = useSecurity('Trading', 'SpendsSet');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(
        [
          'Areas/Trading/Scripts/Resources/en/res.RevenueForecastStream.en.js',
          'Areas/Trading/Scripts/Resources/en/res.ClientProfilePeriod.en.js',
          'Areas/Trading/Scripts/Resources/en/res.AgencyProfilePeriod.en.js',
          'Areas/Master/Scripts/Resources/en/res.RevenueStream.en.js',
          'Areas/Trading/Scripts/Resources/en/Types.en.js',
          'Areas/Trading/Scripts/Resources/en/res.Trading.en.custom.js',
          'Areas/Trading/Scripts/Enums.js',
          'Areas/Trading/Scripts/RevenueForecastStream/Index.custom.js',
          'Areas/Trading/Scripts/RevenueForecastStream/View.custom.js',
          'Areas/Trading/Scripts/jquery.shared.custom.js',
        ],
        'initSearchRevenueForecastIndex',
        {
          canEdit: true,
          canCreate: true,
          canRemove: true,
          id: id,
          appSettings: currentSecurity.profile.AppSettings.Values,
        },
      );
    }
  }, []);
  return (
    <div className="panelcontent-section" style={{ display: 'none' }}>
      <div id="sidebar-section">
        <i className="fas fa-bars" id="sidebarBar"></i>
        <div className="k-content">
          <h3>RevenueForecast</h3>
          <div className="field shortcontrol-container">
            <label className="required">Forecast Year</label>
            <input id="inputYear" />
          </div>
          <div className="field fullwidth-container">
            <label className="required">Agency Profile</label>
            <input id="inputAgencyProfile" />
          </div>
          <div className="field fullwidth-container">
            <label className="required">Agency Profile Period</label>
            <input id="inputAgencyProfilePeriod" />
          </div>
          <div className="field fullwidth-container">
            <label className="required">Client Profile</label>
            <input id="inputClientProfilePeriod" />
          </div>
          <section className="button-toolbar">
            <div className="right">
              <button id="applyFilterButton" type="button" className="k-button k-primary" title="Go">
                Go
              </button>
            </div>
          </section>
        </div>
      </div>
      <div id="content-section" className="collapsed">
        <i className="fas fa-bars" id="contentBar" style={{ display: 'none' }}></i>
        <div id="RevenueForecastContainer" className="k-content">
          <div id="RevenueForecastContent" className="k-content k-block">
            <div id="RevenueForecastStreamToolbar"></div>
            <div id="RevenueForecastStreamContainer" className="spreadsheet-container">
              <div id="RevenueForecastStreamSpreadsheet" style={{ width: '100%' }}></div>
            </div>
            <div id="RevenueForecastStreamChart" style={{ display: 'none' }}>
              <div className="evolution-chart"></div>
            </div>
          </div>
          <div id="RevenueForecastNotify" style={{ display: 'none' }}></div>
        </div>
      </div>
    </div>
  );
}
